var map = {
	"./athletes-ic.svg": 930,
	"./balanced-ic.svg": 931,
	"./customized-plan-ic.svg": 932,
	"./flexible-carnivore-ic.svg": 933,
	"./gain-ic.svg": 934,
	"./keto-ic.svg": 935,
	"./trim-ic.svg": 936,
	"./vegan-ic.svg": 937,
	"./vegetarian-ic.svg": 938,
	"./weight-loss-ic.svg": 939
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;